import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IPriceItemProps {
  price: React.ReactChild;
  priceTooltip?: React.ReactChild | null;
  caption: React.ReactChild;
  captionTooltip?: React.ReactChild | null;
  testId?: string;
}

export const PriceItem: React.FC<IPriceItemProps> = props => {
  const { price, priceTooltip, caption, captionTooltip, testId } = props;

  return (
    <div data-testid={testId}>
      <div className={styles['price']}>
        <ArticleHeading2>{price}</ArticleHeading2>
        {priceTooltip && <div className={styles['price_tooltip']}>{priceTooltip}</div>}
      </div>
      <div className={styles['caption']}>
        <ArticleParagraph1>{caption}</ArticleParagraph1>
        {captionTooltip && <div className={styles['caption_tooltip']}>{captionTooltip}</div>}
      </div>
    </div>
  );
};

PriceItem.displayName = 'PriceItem';
